import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2b0de90a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b0de90a')) {
      api.createRecord('2b0de90a', component.options)
    } else {
      api.reload('2b0de90a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2b0de90a", function () {
      api.rerender('2b0de90a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/index.vue"
export default component.exports